import(/* webpackMode: "eager", webpackExports: ["AnalyticsContactCta"] */ "/vercel/path0/apps/storefront/src/components/AnalyticsContactCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsFeaturedProducts"] */ "/vercel/path0/apps/storefront/src/components/AnalyticsFeaturedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsFormRender"] */ "/vercel/path0/apps/storefront/src/components/AnalyticsFormRender.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundVideo"] */ "/vercel/path0/apps/storefront/src/components/backgrounds/BackgroundVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookingWidgetForms"] */ "/vercel/path0/apps/storefront/src/components/BookingWidgetForms.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/src/components/embeds/BookingCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FareharborInlineEmbed"] */ "/vercel/path0/apps/storefront/src/components/embeds/FareharborInlineEmbed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FareharborLightboxButton"] */ "/vercel/path0/apps/storefront/src/components/embeds/FareharborLightboxButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialEmbedSection"] */ "/vercel/path0/apps/storefront/src/components/embeds/SocialEmbedSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoEmbedSection"] */ "/vercel/path0/apps/storefront/src/components/embeds/VideoEmbedSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/src/components/FeatureCardChoice.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["FormPopoverTrigger"] */ "/vercel/path0/apps/storefront/src/components/FormPopoverTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroScrollCue"] */ "/vercel/path0/apps/storefront/src/components/HeroScrollCue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductFinderSection"] */ "/vercel/path0/apps/storefront/src/components/ProductFinderSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/src/components/RenderedMediaPing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabbedContentSection"] */ "/vercel/path0/apps/storefront/src/components/TabbedContentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CatalogHome"] */ "/vercel/path0/apps/storefront/src/templates/home/CatalogHome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LucideProvider","useLucideContext"] */ "/vercel/path0/node_modules/.pnpm/lucide-react@1.8.0_react@19.2.5/node_modules/lucide-react/dist/esm/context.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/lucide-react@1.8.0_react@19.2.5/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared-ui/src/components/carousel/CarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","CONSENT_SOURCES"] */ "/vercel/path0/packages/shared-ui/src/components/content/ConsentChip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MapSection"] */ "/vercel/path0/packages/shared-ui/src/components/content/MapSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MasonryGallery"] */ "/vercel/path0/packages/shared-ui/src/components/content/MasonryGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WallOfLoveSection"] */ "/vercel/path0/packages/shared-ui/src/components/content/WallOfLoveSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnnouncementBarItem"] */ "/vercel/path0/packages/shared-ui/src/components/navigation/AnnouncementBarItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnnouncementBarRotator"] */ "/vercel/path0/packages/shared-ui/src/components/navigation/AnnouncementBarRotator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandShowcaseHeader"] */ "/vercel/path0/packages/shared-ui/src/components/navigation/BrandShowcaseHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNav"] */ "/vercel/path0/packages/shared-ui/src/components/navigation/MobileNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared-ui/src/components/navigation/NewsletterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewerAvatar"] */ "/vercel/path0/packages/shared-ui/src/components/reviews/ReviewerAvatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewHubButton"] */ "/vercel/path0/packages/shared-ui/src/components/reviews/ReviewHubButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewHubPanel"] */ "/vercel/path0/packages/shared-ui/src/components/reviews/ReviewHubPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewTeaserCard"] */ "/vercel/path0/packages/shared-ui/src/components/reviews/ReviewTeaserCard.tsx");
